import Column from '@components/Column';
import Row from '@components/Row';
import Skeleton from '@components/Skeleton';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';

interface Props {
    count?: number;
}

function ShopItemSkeletons({ count = 3 }: Props) {
    return (
        <Column fullWidth aria-busy>
            {Array.from({ length: count }).map((_, idx) => (
                <ShopItemSkeleton key={`shop-item-sk-${idx}`} />
            ))}
        </Column>
    );
}

function ShopItemSkeleton() {
    const { shopImageShape } = useAppCustom().shop;
    return (
        <Container fullWidth spacing={4} align='flex-start'>
            <Skeleton width={100}
                height={100}
                shape={shopImageShape === 'RECTANGLE' ? 'text' : 'circle'} />
            <Content spacing={4}>
                <Column fullWidth spacing={1}>
                    <Row fullWidth justify='space-between' spacing={2}>
                        <Skeleton width='50%' height={22} />
                        <Skeleton width={24} height={24} shape='circle' />
                    </Row>
                    <Skeleton height={17} />
                    <Skeleton width='70%' height={17} />
                </Column>
                <Row spacing={2}>
                    <Skeleton width={32} height={20} />
                    <Skeleton width={40} height={18} />
                    <Skeleton width={40} height={18} />
                </Row>
            </Content>
        </Container>
    );
}

const Container = styled(Row)`
    padding: var(--spacing-4) 0;
`;

const Content = styled(Column)`
    flex: 1;
    min-width: 0;
`;

export default ShopItemSkeletons;
